import React from "react";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

interface LoadingProps {
    isLoading?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
                            isLoading
                        }: LoadingProps) => {

    const {classes} = useStyles();

    return (
        <Backdrop open={isLoading!} className={classes.backdrop}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};
